import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var CurrentUser = require("lib/account/CurrentUser");

require("data/exports/school_org_stats_selector.scss");

@connect(
    (state, props) => {
        // aggregate school orgs
        var schoolOrgs = []
        var admin = RosterSelectors.admin({ state, id: props.currentAdmin.id || CurrentUser.get().id })
        var loadingDistrictOrgs = RosterSelectors.isLoadingDistrictOrgs({ state, key: 'index' })

        if (CurrentUser.isSchoolAdmin()) {
            if (admin.org_ids.school_orgs && admin.org_ids.school_orgs.all) {
                var schoolOrgs = RosterSelectors.schoolOrgs({
                    state, conditions: { ids: admin.org_ids.school_orgs.all }
                })
            }
        } else {
            if (admin.org_ids.district_orgs && admin.org_ids.district_orgs.primary) {
                var selectedDistrictOrg = RosterSelectors.districtOrg({
                    state, id: admin.org_ids.district_orgs.primary[0]
                })

                if (selectedDistrictOrg) {
                    var schoolOrgs = RosterSelectors.schoolOrgs({
                        state, conditions: { ids: _.map(selectedDistrictOrg.school_orgs, (so) => so.id) }
                    })
                }

            }
        }

        return {
            schoolOrgs,
            loadingDistrictOrgs
        }
    },

    (dispatch, props) => ({
        // fetch school orgs for a district
        populateData: () => {
            var { currentAdmin } = props
            if (currentAdmin && currentAdmin.role == 'districtAdminRole') {
                if (currentAdmin.org_ids && currentAdmin.org_ids.district_orgs && currentAdmin.org_ids.district_orgs.primary) {
                    return Promise.all([dispatch(RosterActions.fetchDistrictOrgs({
                        filters: { ids: currentAdmin.org_ids.district_orgs.primary },
                        embeds: ['district_org.school_orgs'],
                        cache: false
                    }))])
                }
            }
        }
    })
)
    
@providePopulateData({ waitForLoad: true })
class SchoolOrgSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSchoolOrg: null
        };
    }

    ///// HELPERS /////
    renderErrorAlert(text) {
        window.wrNotifications.triggerDropDownNotification({
            text: text,
            icon: "exclamation-sign", type: "error"
        }, 3000);
    }

    retreatePossible() {
        var { track } = this.props
        return _.indexOf(track, _.findWhere(track, { name: 'school-org-selector' })) > 0
    }

    ///// HANDLERS /////
    handleSchoolOrgChange(schoolOrgID) {
        var { schoolOrgs } = this.props
        var schoolOrg = _.findWhere(schoolOrgs, { id: parseInt(schoolOrgID) })
        var selectedSchoolOrg = schoolOrg ? { id: schoolOrg.id, name: schoolOrg.name } : null
        this.setState({ selectedSchoolOrg })
    }

    handleRetreatStage() {
        var { selectedSchoolOrg } = this.state
        this.props.onRetreat({ selectedSchoolOrg })
    }

    ///// SUBMIT /////
    onSubmit() {
        var { selectedSchoolOrg } = this.state
        if (!selectedSchoolOrg) {
            this.renderErrorAlert("Please Select a School Org")
        } else {
            this.props.onComplete({ selectedSchoolOrg })
        }
    }

    ///// RENDER METHODS /////
    renderSchoolOrgSelector() {
        return (
            <div className="selectorContainer">
                <select placeholder="Select a School Org" onChange={e => this.handleSchoolOrgChange(e.target.value)} className="selectElement">
                    <option value={''}>Select a School Org</option>
                    {this.props.schoolOrgs.map(s => (
                        <option value={s.id} key={s.id}>{s.name}</option>
                    ))}
                </select>
            </div>
        )
    }

    render() {
        return (
            <div className="schoolOrgDropdownSelectorContainer">
                {this.renderSchoolOrgSelector()}
                <div className="onSubmitContainer">
                    {this.retreatePossible() && (
                        <button className='backBtn' onClick={() => this.handleRetreatStage()}>Back</button>
                    )}
                    {this.state.selectedSchoolOrg && (
                        <button className='nextBtn' onClick={() => this.onSubmit()}>Next</button>
                    )}
                </div>
            </div>
        );
    }

    componentDidMount() {
        var { persistentData } = this.props

        // preset selected school org if previously selected
        if (persistentData.selectedSchoolOrg) {
            this.setState({ selectedSchoolOrg: persistentData.selectedSchoolOrg })
        }
    }
}

SchoolOrgSelector.propTypes = StrictPropTypes({
    endOnboarding: PropTypes.func,
    handleAdvanceStage: PropTypes.func,
    onSubmit: PropTypes.func,
    onComplete: PropTypes.func,
    onRetreat: PropTypes.func,
    track: PropTypes.array,
    persistentData: PropTypes.object,
    currentAdmin: PropTypes.object,
    organizationTypes: PropTypes.array,
    organizationOptions: PropTypes.array,
    handlePrint: PropTypes.func,
});

module.exports = SchoolOrgSelector;


// WEBPACK FOOTER //
// ./modules/components/data/exports/SchoolOrgSelector.js